module.exports = __webpack_public_path__ + "static/img/pic_news1.3340c5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/news/pic_news1.jpg
// module id = KCwu
// module chunks = 0